import type { ReactNode } from "react";
import { useSession } from "@/shared/auth/session";
import { EmployeeOnlyPage } from "../pages/EmployeeOnlyPage";
import { isEmployeeOnlySession } from "../utils/employee-only";

/**
 * Wrap the signed-in shell in this (C1-15): an employee-only membership gets the "use the mobile app"
 * page in place of everything else — any address, any reload, any bookmark — and every other member gets
 * the portal unchanged. It sits inside `RequireSession`, which is what provides the session it reads.
 */
export function EmployeeOnlyGate({ children }: { children: ReactNode }) {
  const session = useSession();
  return isEmployeeOnlySession(session) ? <EmployeeOnlyPage /> : children;
}
